import { useCallDurationRule } from "@/hooks/useCallDurationRule/useCallDurationRule";

import { useCall } from "../useCall/useCall";
import { useTranscriptionRule } from "../useTranscriptionRules/useTranscriptionRules";

export function useSummaryRule() {
  const { isCallDurationLow } = useCallDurationRule();
  const { isAvailableCall } = useTranscriptionRule();
  const { call } = useCall();

  const shouldDisplaySummary =
    isAvailableCall && call?.type !== "voicemail" && !isCallDurationLow;

  return {
    shouldDisplaySummary,
  };
}
